import { UserRole } from 'models/user'

import { ROUTER_NAMES } from './routerNames'

export const ROUTER_REDIRECTS: Record<UserRole, string> = {
  [UserRole.ONLY_VIEW]: ROUTER_NAMES.APPLICATIONS,
  [UserRole.Administrator]: ROUTER_NAMES.APPLICATIONS,
  [UserRole.AdministratorCIB]: ROUTER_NAMES.USERS,
  [UserRole.Controller]: ROUTER_NAMES.APPLICATIONS,
  [UserRole.SuperController]: ROUTER_NAMES.ATTRACTORS,
  [UserRole.Supervisor]: ROUTER_NAMES.NEW_TERRITORIES,
  [UserRole.Manager]: ROUTER_NAMES.USERS,
  [UserRole.Consultant]: ROUTER_NAMES.NOT_FOUND,
  [UserRole.Author]: ROUTER_NAMES.LOGISTIC,
  [UserRole.Executor]: ROUTER_NAMES.LOGISTIC,
  [UserRole.ControllerUKC]: ROUTER_NAMES.LOGISTIC,
  [UserRole.Specialist]: ROUTER_NAMES.CONTACT_CENTER,
  [UserRole.SPECIALIST_B2B]: ROUTER_NAMES.NOT_FOUND,
  [UserRole.Deliveryman]: ROUTER_NAMES.NOT_FOUND,
}

export const ROUTER_RELOAD_DOCUMENT_REDIRECTS = [
  ROUTER_NAMES.NEW,
  ROUTER_NAMES.NEW_TERRITORIES,
  ROUTER_NAMES.ISSUANCE,
]
